import { extendTheme } from "@chakra-ui/react";
import "@fontsource/khmer";
import "@fontsource/poppins";
import "@fontsource/inter";
import "@fontsource/kantumruy-pro";
import "@fontsource/content";
import "@fontsource/moul";
import chroma from 'chroma-js';

export const config = {
  initialColorMode: "light",
  useSystemColorMode: false,
};

// * auto generate brand color by passing base color (500)
const baseColor = "#2574b9";
const brandColors = chroma.scale([chroma(baseColor).brighten(2), baseColor, chroma(baseColor).darken(2)]).colors(9);

export const theme = extendTheme({
  config,
  colors: {
    brand: {
      50: "#454959",
      100: brandColors[1],
      200: brandColors[2],
      300: brandColors[3],
      400: brandColors[4],
      500: brandColors[5],
      600: brandColors[6],
      700: brandColors[7],
      800: brandColors[8],
      900: brandColors[9],
    },
    redAlt: {
      50: "#fff7f7",
      100: "#ffefef",
      200: "#ffd6d6",
      300: "#ffbdbd",
      400: "#ff8c8c",
      500: "#ff5b5b",
      600: "#e65252",
      700: "#bf4444",
      800: "#993737",
      900: "#7d2d2d",
    },
  },
  styles: {
    global: {
      "*": {
        "&::-webkit-scrollbar": {
          width: "7px",
          height: "7px",
        },
        "&::-webkit-scrollbar-thumb": {
          background: "#a8a8a8",
          borderRadius: "24px",
          transition: "width 0.2s, background-color 0.2s",
          "&:hover": {
            width: "7px", // Increase width on hover
            background: "#888", // Change background on hover
          },
        },
        "&::-webkit-scrollbar-track": {
          width: "6px",
          height: "4px",
          background: "transparent",
        },
        b: {
          color: "red",
        },
        scrollbarWidth: "thick",
      },
      ".gm-ui-hover-effect": {
        display: "none !important",
      },

      ".infoBox": {
        overflow: "initial !important",
        zIndex: "-1000 !important",
      },
      ".infoBox img": {
        display: "none !important",
      },
      ".gm-control-active": {
        zIndex: "var(--chakra-zIndices-docked)",
      },
      ".gmnoprint:last-child": {
        float: "right",
      },
    },
  },

  fontSizes: {
    sm: "0.83rem",
    md: "0.9rem",
  },
  fonts: {
    heading: "Poppins, sans-serif",
    body: "Kantumruy Pro, sans-serif",
    kh: "Khmer OS Battambang,khmer, sans-serif",
    content: "Kantumruy Pro, sans-serif",
    moul: "Moul, sans-serif",
  },
  components: {
    Button: {
      baseStyle: {
        // fontWeight: "medium",
      },
      variants: {
        duotone: (props) => ({
          bg: `${props.colorScheme}.100`,
          color: `${props.colorScheme}.600`,
          border: `1px solid`,
          px: "var(--chakra-space-3)",
          borderColor: `${props.colorScheme}.500`,
          _hover: { bg: `${props.colorScheme}.200` },
        }),
      },
    },
    Input: {
      defaultProps: {
        focusBorderColor: "brand.400",
      },
      variants: {
        outline: {
          field: {
            _disabled: {
              opacity: 1,
              _hover: {
                borderColor: "inherit",
                cursor: "default",
              },
            },
          },
        },
      },
    },
    CheckBox: {
      variants: {
        bg: "brand.100",
      },
    },
    NumberInput: {
      defaultProps: {
        focusBorderColor: "brand.400",
      },
    },
    Textarea: {
      defaultProps: {
        focusBorderColor: "brand.400",
      },
      variants: {
        outline: {
          _disabled: {
            opacity: 1,
            _hover: {
              borderColor: "inherit",
              cursor: "default",
            },
          },
        },
      },
    },
  },
});

// Card style all
export const containerStyles = {
  border: "2px solid #ddd",
  background: "#fff",
  borderRadius: "0",
  height: "auto",
};

// Card style internationalDashboard
export const containerCardStyles = {
  border: "2px solid #ddd",
  background: "#fff",
  borderRadius: "0",
  height: "49%",
  width: "100%",
  padding: "0",
};